import React, { useState } from 'react';
import axios from 'axios';

const Result = () => {
  return (
    <p className="success-message">
      Your message has been successfully sent. I will contact you soon.
    </p>
  );
};

function ContactForm({ formStyle }) {
  const [result, showResult] = useState(false);
  const [error, setError] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const sendEmail = async (e) => {
    e.preventDefault();

    const formData = {
      fullname: e.target.fullname.value,
      email: e.target.email.value,
      phone: e.target.phone.value,
      whatsapp: e.target.whatsapp.value,
      subject: e.target.subject.value,
      message: e.target.message.value,
    };

    try {
      setError(null);
      const response = await axios.post(`${API_BASE_URL}/contact`, formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log('Response:', response.data);
      showResult(true);
      e.target.reset();

      setTimeout(() => {
        showResult(false);
      }, 5000);
    } catch (err) {
      console.error(err);
      setError('Something went wrong. Please try again later.');
    }
  };

  return (
    <form className={`${formStyle}`} onSubmit={sendEmail}>
      <div className="form-group">
        <input type="text" name="fullname" placeholder="Your Name" required />
      </div>

      <div className="form-group">
        <input type="email" name="email" placeholder="Email Address" required />
      </div>

      <div className="form-group">
        <input type="text" name="phone" placeholder="Phone Number" required />
      </div>

      <div className="form-group">
        <input type="text" name="whatsapp" placeholder="Whatsapp Number" required />
      </div>

      <div className="form-group">
        <input type="text" name="subject" placeholder="Subject" required />
      </div>

      <div className="form-group">
        <textarea name="message" placeholder="Your Message" required></textarea>
      </div>

      <div className="form-group">
        <button className="btn-default btn-large" type="submit">
          Submit Now
        </button>
      </div>

      <div className="form-group">
        {result && <Result />}
        {error && <p className="error-message">{error}</p>}
      </div>
    </form>
  );
}

export default ContactForm;
